import { SkeletonRectangle } from '@leagueplatform/genesis-core';
import {
  MasonryEngineNode,
  MasonryEngineNodeRendererProps,
} from '@leagueplatform/masonry-engine';
import React, { forwardRef } from 'react';
import { Props } from './types';

export const ExtraSmallSkeleton = forwardRef<HTMLDivElement, Props>(
  ({ ...props }, ref) => (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <SkeletonRectangle height={96} ref={ref} {...props} />
  ),
);

export type ExtraSmallSkeletonWSNode = MasonryEngineNode<
  'loadingExtraSmall',
  Props
>;

export const ExtraSmallSkeletonWSRenderer = ({
  rootElementRef,
  ...props
}: MasonryEngineNodeRendererProps<ExtraSmallSkeletonWSNode>) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <ExtraSmallSkeleton ref={rootElementRef} {...props} />
);
